import isNil from 'lodash.isnil';
export const getDefaultAddDocumentsFormModel = () => ({
    clientName: null,
    companyId: null,
    documents: []
});
export const getClientsOptions = (records) => records.map(record => ({
    value: record.clientName,
    renderOption: record.clientName
}));
export const getCompaniesOptions = (records, selectedClientName) => {
    const client = records.find(record => record.clientName === selectedClientName);
    if (isNil(client))
        return [];
    return client.companies.map(company => ({
        value: company.companyId,
        renderOption: company.companyName
    }));
};
export const getDefaultDocumentsFilterFormModelState = () => ({
    hasAssociatedCalculations: []
});
